import React from 'react';
import { MdArrowBack, MdLogout } from 'react-icons/md';
import type { Integration } from '../types';

interface IntegrationHeaderProps {
  integration: Integration;
  isConnected: boolean;
  onBack: () => void;
  onLogout: () => void;
  disabled?: boolean;
}

const IntegrationHeader: React.FC<IntegrationHeaderProps> = ({
  integration,
  isConnected,
  onBack,
  onLogout,
  disabled,
}) => {
  return (
    <div className=" border-b border-gray-800">
      <div className=" pb-2 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button
            onClick={onBack}
            className="text-gray-300 cursor-pointer hover:text-white transition-colors"
          >
            <MdArrowBack size={24} />
          </button>
          <div className="flex items-center gap-4">
            <div
              className="w-8 h-8 flex items-center rounded-full justify-center"
              style={{ backgroundColor: integration.color }}
            >
              <span className="text-white text-xl">{integration.icon}</span>
            </div>
            <h1 className="text-white text-xl font-medium">{integration.name}</h1>
          </div>
        </div>

        {isConnected && (
          <button
            onClick={onLogout}
            disabled={disabled}
            className="cursor-pointer w-10 h-10 rounded-full bg-brand-primary hover:bg-[#ee4423] flex items-center justify-center transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            title="Logout"
          >
            <MdLogout size={20} className="text-white" />
          </button>
        )}
      </div>
    </div>
  );
};

export default IntegrationHeader;
